import { render, staticRenderFns } from "./MainNavbarIconOption.vue?vue&type=template&id=bd974528"
import script from "./MainNavbarIconOption.vue?vue&type=script&setup=true&lang=js"
export * from "./MainNavbarIconOption.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports